<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      :search.sync="query"

      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="feeInvoiceTypeIdForm" slot-scope="scope">
        <el-select
          v-model="form.feeInvoiceTypeId"
          placeholder="请选择发票类型"
          style="width: 100%"
        >
          <el-option
            v-for="item in feeInvoiceTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          v-if="permissionList.sync"
          icon="el-icon-share"
          plain
          @click="openCutPaymentAddDialog(scope.row)"
          >同 步
        </el-button>
        <el-dialog
          title="同步"
          :visible.sync="cutPaymentAddShowDialogFlag"
          @close="quitCutPaymentAddDialog"
          :modal-append-to-body="false"
        >
          <div class="el-property-dialog-div">
            <avue-form
              v-loading="cutFormLoading"
              :element-loading-text="cutFormLoadingText"
              ref="cutPaymentAddFormRef"
              v-model="cutPaymentAddForm"
              :option="syncAddOption"
              @submit="cutPaymentAddSubmit"
            >
              <template slot-scope="scope" slot="menuForm">
                <el-button @click="quitCutPaymentAddDialog">返回</el-button>
              </template>
            </avue-form>
          </div>
        </el-dialog>
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   v-if="permissionList.delBtn"
                   plain
                   @click="handleDelete">删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  sync,
} from '@/api/v4ward/digitaltickets/feeSeller';
import {
  getInvoiceTypeList,
} from '@/api/v4ward/digitaltickets/invoiceType';
import { mapGetters } from 'vuex';
import syncAddOption from './seller-sync-option';
import { getOptionNode } from '@/api/v4ward/property/baseproperty';
import { getCommunityGroupList } from '../../../api/common';

export default {
  data() {
    return {
      feeInvoiceTypeList: [],
      form: {},
      query: {},
      loading: false,
      cutPaymentAddForm: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      cutPaymentAddShowDialogFlag: false,
      selectionList: [],
      syncAddOption: syncAddOption,
      cutFormLoading: false,
      cutFormLoadingText: '',
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        labelWidth: 130,
        searchMenuSpan: 24,
        // searchMenuPosition: "right",
        menuWidth: 250,
        border: true,
        index: false,
        viewBtn: true,
        selection: true,
        dialogClickModal: false,
        column: [
          {
            label: '小区分组',
            prop: 'communityId',
            type: 'select',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            search: true,
            searchSpan: 6,
            hide: true,
            dicData: [],
            props: { label: 'dictValue', value: 'dictKey' },
            // searchValue: "1",
            rules: [
              {
                required: true,
                message: '小区分组',
                trigger: 'blur',
              },
            ],
          },
          {
            label: 'id',
            prop: 'id',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            disabled: true,
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入id',
                trigger: 'change',
              },
            ],
          },
          {
            label: '所属小区',
            prop: 'areaName',
            order: 14,
            search: true,
            searchSpan: 6,
            disabled: true,
            searchClearable: false,
            dicData: [],
            props: {
              label: "roomName",
              value: "roomName",
            },
            type: "select",
            maxlength: 100,
            rules: [
              {
                required: true,
                message: '请选择所属小区',
                trigger: 'change',
              },
            ],
          },
          {
            label: '名称',
            prop: 'sellerName',
            order: 13,
            search: true,
            searchSpan: 6,
            maxlength: '50',
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '纳税人识别号',
            width: 100,
            order: 12,
            prop: 'taxNo',
            maxlength: '50',
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入纳税人识别号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '纳税人类型',
            width: 100,
            order: 11,
            prop: 'taxType',
            type:"select",
            dicUrl: "/api/blade-system/dict/dictionary?code=tax_type",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            rules: [
              {
                required: true,
                message: '请输入纳税人类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '联系人',
            prop: 'contacts',
            maxlength: '50',
            order: 8,
            showWordLimit: true,
            rules: [
              {
                required: false,
                message: '请输入联系人',
                trigger: 'change',
              },
            ],
          },
          {
            label: '联系电话',
            prop: 'phone',
            maxlength: '20',
            order: 7,
            showWordLimit: true,
            rules: [
              {
                pattern:
                  /^([1]\d{10}|([(（]?0[0-9]{2,3}[）)]?[-]?)?([2-9][0-9]{6,7})+(-[0-9]{1,4})?)$/,
                message: '格式错误',
              },
              {
                required: false,
                message: '请输入电话',
                trigger: 'change',
              },
            ],
          },
          {
            label: '开户银行',
            prop: 'depositBank',
            maxlength: '50',
            order: 10,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入开户银行',
                trigger: 'change',
              },
            ],
          },
          {
            label: '银行账号',
            prop: 'bankNo',
            maxlength: '50',
            order: 9,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入开户银行账号',
                trigger: 'change',
              },
            ],
          },
          {
            label: "发票类型",
            prop: "feeInvoiceTypeId",
            order: 6,
            hide: true,
            showColumn:false,
            formslot: true,
            rules: [{
              required: true,
              message: "请选择发票类型",
              trigger: "change"
            }]
          },
          {
            label: "发票类型",
            prop: "feeInvoiceTypeName",
            width: 120,
            overHidden: true,
            viewDisplay: false,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '地址',
            prop: 'address',
            maxlength: '200',
            span:24,
            order: 5,
            showWordLimit: true,
            rules: [
              {
                required: false,
                message: '请输入地址',
                trigger: 'change',
              },
            ],
          },
          {
            label: '是否默认',
            prop: 'isDefault',
            type: 'switch',
            order: 4,
            span:8,
            dicData: [
              { label: '否', value: 0 },
              { label: '是', value: 1 },
            ],
            addDisplay: true,
            editDisplay: true,
            rules: [
              {
                required: false,
                message: '请选择是否默认',
                trigger: 'change',
              },
            ],
          },
          {
            label: '状态',
            prop: 'status',
            type: 'switch',
            span:8,
            order: 3,
            search: true,
            searchSpan: 6,
            dicData: [
              { label: '禁用', value: 0 },
              { label: '启用', value: 1 },
            ],
            addDisplay: true,
            editDisplay: true,
            rules: [
              {
                required: false,
                message: '请选择状态',
                trigger: 'change',
              },
            ],
          },
          {
            label: '微信开票默认销方',
            prop: 'isWechatDefault',
            maxlength: 100,
            span:8,
            order: 2,
            type: 'switch',
            dicData: [
              { label: '否', value: 0 },
              { label: '是', value: 1 },
            ],
            addDisplay: true,
            editDisplay: true,
            rules: [
              {
                required: false,
                message: '微信开票默认销方',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注',
            prop: 'remark',
            type: 'textarea',
            maxlength: '200',
            span:24,
            showWordLimit: true,
            addDisplay: true,
            editDisplay: true,
            order: 1,
          },
        ],
      },
      data: [],
      tempCommunityGroup:'',
      tempAreaName:'',
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.seller_add, false),
        viewBtn: this.vaildData(this.permission.seller_view, false),
        delBtn: this.vaildData(this.permission.seller_delete, false),
        editBtn: this.vaildData(this.permission.seller_edit, false),
        sync: this.vaildData(this.permission.seller_sync, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  watch: {
    'cutPaymentAddForm.areaGroup'(val) {
      getOptionNode({communityGroup:val|| ''}).then((data) => {
        const column = this.findObject(this.syncAddOption.column, "areaName");
        column.dicData = [
          {
            roomName: '全部',
            children: data.data.filter(ele => ele.id != '-1')
          }
        ];
      });
    },
   /* 'form.communityId'(val) {
      getOptionNode({communityGroup:val|| ''}).then((data) => {
        const column = this.findObject(this.option.column, "areaName");
        column.dicData = data.data;
      });
    },*/
    'query.communityId'(val) {
      this.tempCommunityGroup = val;
      if(!val){
        return;
      }
      getOptionNode({communityGroup:val|| ''}).then((data) => {
        let communityArr = data.data.filter(ele => ele.id != '-1');
        const column = this.findObject(this.option.column, "areaName");
        column.dicData = communityArr;
        this.query.areaName = communityArr[0].roomName;
        this.onLoad();
      });
    },
    'query.areaName'(val) {
      this.tempAreaName = val;
    },
  },
  created(){
    getCommunityGroupList().then((res) => {
      if(res){
        this.findObject(this.option.column,'communityId').dicData = res.data;
        this.query.communityId = res.data[0].dictKey;
      }
    });
    this.initFeeInvoiceTypeList();
  },
  methods: {
    initFeeInvoiceTypeList() {
      getInvoiceTypeList().then((res) => {
        this.feeInvoiceTypeList = res.data;
      }, error => {
        window.console.log(error);
      });
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    sync(row) {
      this.$confirm('是否设置为默认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return sync({ id: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }else{
        this.form={
          areaName:this.query.areaName,
          communityId:this.query.communityId,
          isDefault:1,
          status:1,
          isWechatDefault:1,
          feeInvoiceTypeId: '',
        }
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.query.communityId = this.tempCommunityGroup;
      this.query.areaName = this.tempAreaName;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    openCutPaymentAddDialog() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.cutPaymentAddForm.areaGroup = "1";
      this.cutPaymentAddShowDialogFlag = true;
    },
    quitCutPaymentAddDialog() {
      this.cutPaymentAddShowDialogFlag = false;
      this.$refs.cutPaymentAddFormRef.resetForm();
    },
    cutPaymentAddSubmit(form, done) {
      if (form.areaName.length === 0) {
        this.$message.warning('请选择所属小区');
        return;
      }
      sync({ ids:this.ids,areaNames:form.areaName ,communityId: form.areaGroup}).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.cutPaymentAddShowDialogFlag = false;
          this.$refs.cutPaymentAddFormRef.resetForm();
          done();
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    onLoad(page) {
      page = page || this.page;
      if(!this.query.communityId){
        return;
      }
      this.loading = true;
      if(!this.query.areaName){
        getOptionNode({communityGroup:this.query.communityId}).then((data) => {
          this.query.areaName=data.data[0].roomName;
          getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
            ({ data }) => {
              this.page.total = data.total;
              this.data = data.records;
              this.loading = false;
              this.selectionClear();
            }
          );
        });
      }else{
        getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
          ({ data }) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
          }
        );
      }

    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}
</style>
